import { state } from '../state';
import { formatTime } from '../ui';
import { triggerDownload } from './index';

interface DocxLib {
  Document: new (cfg: unknown) => unknown;
  Packer: { toBlob(doc: unknown): Promise<Blob> };
  Paragraph: new (cfg: unknown) => unknown;
  TextRun: new (cfg: unknown) => unknown;
}

declare global {
  interface Window {
    docx?: DocxLib;
  }
}

export async function exportDocx(includeTimestamps: boolean): Promise<void> {
  if (state.paragraphs.length === 0 || !window.docx) return;
  const { Document, Packer, Paragraph, TextRun } = window.docx;

  const paragraphs = state.paragraphs.map((p) => {
    const time = includeTimestamps ? `[${formatTime(p.start)}] ` : '';
    const name = state.speakerMap[p.speaker] ?? `Speaker ${p.speaker}`;
    return new Paragraph({
      children: [
        new TextRun({ text: `${time}${name}:`, bold: true }),
        new TextRun({ text: ` ${p.text}` }),
      ],
      spacing: { after: 200 },
    });
  });

  const doc = new Document({
    sections: [{ properties: {}, children: paragraphs }],
  });

  const blob = await Packer.toBlob(doc);
  triggerDownload(blob, 'Transcripcion_Scribe.docx');
}
